import { createSlice } from "@reduxjs/toolkit";
import { archiveProjectList } from "./projectAsyncThunk";

const archiveProjectListSlice = createSlice({
  name: "project",
  initialState: {
    payload: [],
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [archiveProjectList.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [archiveProjectList.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.payload = [...action.payload.list];
    },
    [archiveProjectList.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default archiveProjectListSlice.reducer;
